const filterList = [
  { statusName: 'pending', statusKoreanName: '예약 신청', id: 0 },
  { statusName: 'confirmed', statusKoreanName: '예약 승인', id: 1 },
  { statusName: 'canceled', statusKoreanName: '예약 취소', id: 2 },
  { statusName: 'declined', statusKoreanName: '예약 거절', id: 3 },
  { statusName: 'completed', statusKoreanName: '체험 완료', id: 4 },
];

export default filterList;
